import { AchBatchRepository } from '~/repositories/Transfer/AchBatchRepository';
import { ACHTransferBatch } from '~/typings/API';

import { createApiHook } from './utils/createApiHook';

export const useAchBatch = createApiHook<ACHTransferBatch, GetRequestType>(AchBatchRepository.get);
